import { render, staticRenderFns } from "./OrderSlidebar.vue?vue&type=template&id=771eea44"
import script from "./OrderSlidebar.vue?vue&type=script&lang=js"
export * from "./OrderSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports